queryMatches = (first, second) ->
  first.toLowerCase().indexOf( second.toLowerCase().trim() ) != -1

App.StaticPagesEditController = Em.Controller.extend
  session: Em.inject.service()
  notifier: Em.inject.service()

  env:     Em.inject.service('environment')

  needs: [ 'staticPages', 'staticPagesIndex' ]

  pageBinding: 'model'
  pages: Ember.computed ->
    @store.find('static-page')

  parentPages: (->
    @get('pages').filter (_page) => _page.get('id') != @get('page.id') and !(@get('page.childs')?.find (childPage) => childPage.get('id') == _page.get('id'))
  ).property('pages.@each', 'page')

  richTextEditor: null

  disabled: (->
    page = @get('page')
    !page.get('name') || !page.get('slug')
  ).property('page.name', 'page.slug')


  actions: 
    cancel: ->
      page = @get('page')

      if page.get('isDirty') or page.get('isNew')
        # todo i18n
        return unless confirm 'Отменить изменения?'
        page = @get('page')
        page.rollback()

      @send('goBackToPagesList')

      false

    goBackToPagesList: ->
      @transitionTo 'static-pages'
      false

    save: ->
      page = @get('page')
      editor = @get('richTextEditor.editor')
      wasNew = page.get('isNew')

      @set('isLoading', true)
      page.set('content', editor.getData())
      page.save()
      .then =>
        @set('isLoading', false)
        @transitionTo('static-pages') if wasNew
      .catch (err) =>
        @set('isLoading', false)
        if err?.errors
          errorMessage = Object.keys(err.errors).map (el) => 
            pathName = Em.I18n.t "static_pages.edit.#{el}.label"
            message = err.errors[el][0]
            "#{pathName} #{message}"
          .join('\n')
          @get('notifier').pushNotification
            type: 'error'
            title: Em.I18n.t('order.courier_mini_popup.annotation.error')
            message: errorMessage
            duration: 3000

      false

    delete: ->
      return unless confirm Em.I18n.t 'promos.confirm.delete'

      page = @get('page')
      page.destroyRecord()
      .then =>
        @transitionTo('static-pages')

      false
    
    uploadPhoto: (file) ->
      page = @get('page')
      return unless page

      page.set('fileIsUploading', true)

      page.uploadPhoto(file).then =>
        page.reload()
        .finally =>
          page.set('fileIsUploading', false)
      false

    deletePhoto: ->
      page = @get('page')
      page.set('fileIsUploading', true)
      page.deletePhoto().then =>
        page.reload()
        .finally =>
          page.set('fileIsUploading', false)
      false

    openFileDialog: ->
      @get('fileInput').openDialog()
      false